import { createApiConstants } from '@saucelabs/sl-util-redux';

export const NAMESPACE = 'organization';
const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

export const GET_SAML_SETTINGS = createApiNamespacedConstants('get_saml_settings');
export const UPDATE_SAML_SETTINGS = createApiNamespacedConstants('update_saml_settings');
export const DELETE_SAML_FILE = createApiNamespacedConstants('delete_saml_file');
export const UPDATE_SETTING = createApiNamespacedConstants('update_settings');
export const RESET_ACCESS_KEYS = createApiNamespacedConstants('reset_access_keys');
export const POST_RESTRICTED_DOMAIN = createApiNamespacedConstants('post_restricted_domain');
export const PUT_RESTRICTED_DOMAIN = createApiNamespacedConstants('put_restricted_domain');
export const PATCH_SETTINGS = createApiNamespacedConstants('patch_settings');
export const PATCH_US_SSO_SETTINGS = createApiNamespacedConstants('patch_us_sso_settings');
export const GET_ORGANIZATION = createApiNamespacedConstants('get_organization');
